import React from 'react'
import { Box, Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../constants/colors'

type CoachChoiceChipProps = {
  selected: boolean
  /** While a save is in flight every chip is inert, so a second click cannot race the first. */
  disabled: boolean
  onSelect: () => void
  label: string
  description?: string
}

const DISABLED_OPACITY = 0.6

/** A selectable, keyboard-accessible pill used for both the frequency and the voice choice. */
export const CoachChoiceChip: React.FC<CoachChoiceChipProps> = ({
  selected,
  disabled,
  onSelect,
  label,
  description
}) => {
  const activate = () => {
    if (disabled || selected) return
    onSelect()
  }

  return (
    <Box
      role="radio"
      aria-checked={selected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={activate}
      onKeyDown={(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return
        event.preventDefault()
        activate()
      }}
      sx={{
        px: 2,
        py: 1,
        borderRadius: 2,
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled && !selected ? DISABLED_OPACITY : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        border: `1px solid ${selected ? INTERAX_COLORS.sun : INTERAX_COLORS.white10}`,
        backgroundColor: selected ? INTERAX_COLORS.sun20 : INTERAX_COLORS.black20,
        transition: 'all 0.15s ease'
      }}
    >
      <Typography sx={{ color: selected ? INTERAX_COLORS.sun : INTERAX_COLORS.white, fontSize: 14, fontWeight: 600 }}>
        {label}
      </Typography>
      {description && <Typography sx={{ color: INTERAX_COLORS.thunderGrey, fontSize: 12 }}>{description}</Typography>}
    </Box>
  )
}

export default CoachChoiceChip
